import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this ebook really for absolute beginners with no clinical experience?',
  a: 'Yes. The 360° Injury Rehab System is designed for people who have never managed injured athletes or studied clinical protocols. We start from basic anatomy and build everything step by step into complete return-to-sport frameworks.'
}, {
  q: "Can I learn even if I don't have a strong sports medicine background?",
  a: "Absolutely. Every protocol includes visual step-by-step explanations, assessment criteria and clear progression checkpoints. If you can follow instructions and care about your clients' recovery, you can use this system."
}, {
  q: 'Are the protocols and progressions actually useful, or just theoretical examples?',
  a: 'Completely practical. Every protocol is used by elite strength coaches, physical therapists and athletic trainers in real professional settings. These are the frameworks that work with actual athletes.'
}, {
  q: 'Does the ebook include assessment guidance and tips to avoid re-injury?',
  a: 'Yes. Each volume includes specific assessment checkpoints, red flags, progression criteria and return-to-sport testing protocols so you make safe, clinical decisions at every stage.'
}, {
  q: 'How soon will I see real results with my first client?',
  a: 'Many professionals apply their first complete protocol within 48 hours of purchase and report managing their first athlete confidently by week one. Visible client progress typically appears by week 2-3 of consistent application.'
}, {
  q: 'Do I need other courses or can I just use this system?',
  a: 'This is designed to be complete. You get everything: assessment frameworks, exercise progressions, load management, return-to-sport criteria and tracking systems. One purchase, complete knowledge.'
}, {
  q: "What if I don't have 90 minutes every day to study?",
  a: 'The system works in 20-30 minute chunks. Learn one protocol per week, apply it immediately with clients, and build your knowledge progressively. Speed is less important than consistency.'
}, {
  q: 'Is there support if I get stuck or have questions about a specific injury?',
  a: 'Yes. You get access to the private Discord community with elite professionals, case discussion channels and direct feedback on your protocols and client management decisions.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-57" data-mp="33kli0yn5rme2">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-58" data-mp="2ypei81x0f1uf">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-59" data-mp="2unt124dg01ef">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-60" data-mp="1j6bcic4fn8ch">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-61" data-mp="2pm3hx437iha" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-62" data-mp="2qx6vvtmeo7v">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-63" data-mp="hdysga4rc12a">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-64" data-mp="md1z1z0dyfcd" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-65" data-mp="qfosg4cpg8bo" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-66" data-mp="vet18tvpw41h">
                  <div className="overflow-hidden" data-id="element-67" data-mp="2s8mftknpq8p8">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-68" data-mp="2x5mlhugnh9ft">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}